<template>
  <div class="xz-contract">
    <query-form
      class="content_block"
      label-width="116px"
      size="small"
      label-position="right"
      @search="getList('init')"
      @reset="handleReset"
      :keepOpenedRow="2"
    >
      <el-form-item label="合同状态：" :span="24">
        <check-tag v-model="advancedForm.state" @change="() => getList('init')">
          <check-tag-item
            :value="i.value"
            :key="i.value"
            v-for="i in executionStatusGroup"
            :label="`${i.label}(${i.count || 0})`"
          ></check-tag-item>
        </check-tag>
      </el-form-item>
      <el-form-item label="合同编号：">
        <el-input
          v-model.trim="advancedForm.pcCode"
          clearable
          placeholder="请输入合同编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户抬头：">
        <el-input
          v-model.trim="advancedForm.unit"
          clearable
          placeholder="请输入客户抬头"
        ></el-input>
      </el-form-item>
      <el-form-item label="收款状态：">
        <el-select
          v-model.trim="advancedForm.payState"
          clearable
          placeholder="请选择收款状态"
          @change="getList('init')"
        >
          <el-option
            v-for="item in collectionStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货状态：">
        <el-select
          v-model.trim="advancedForm.receivingSts"
          clearable
          placeholder="请选择发货状态"
          @change="getList('init')"
        >
          <el-option
            v-for="item in deliveryStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户联系人：">
        <el-input
          v-model.trim="advancedForm.saleContractCustomerContact"
          clearable
          placeholder="请输入客户联系人"
        ></el-input>
      </el-form-item>
      <el-form-item label="开票状态：">
        <el-select
          v-model.trim="advancedForm.billingState"
          clearable
          placeholder="请选择开票状态"
          @change="getList('init')"
        >
          <el-option
            v-for="(item, index) in billingStatusOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收货人：">
        <el-input
          v-model.trim="advancedForm.receiverName"
          clearable
          placeholder="请输入收货人"
        ></el-input>
      </el-form-item>
      <el-form-item label="收货人手机：">
        <el-input
          v-model.trim="advancedForm.receiverPhone"
          clearable
          placeholder="请输入收货人手机"
        ></el-input>
      </el-form-item>
      <el-form-item label="签订日期(起)：">
        <el-date-picker
          v-model="advancedForm.signStartDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择签订日期(起)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="签订日期(止)：">
        <el-date-picker
          v-model="advancedForm.signEndDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择签订日期(止)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="变更状态：">
        <el-select
          v-model.trim="advancedForm.changeState"
          clearable
          placeholder="请选择变更状态"
          @change="getList('init')"
        >
          <el-option
            v-for="item in changeStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model.trim="advancedForm.remark"
          clearable
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </query-form>
    <ContentBlock>
      <div style="margin-bottom: 10px;"><el-button type="primary" size="mini" @click="handleExport">导出</el-button></div>
      <TableWithPagination
        :columnList="columnList"
        :tableData="dataList"
        :pagination.sync="pagination"
        @size-change="getList"
        @current-change="getList"
        @sort-change="getList"
      />
    </ContentBlock>
  </div>
</template>
<script>
import TableWithPagination, {
  TablePaginationMixin,
} from '@/components/common/TableWithPagination';
import { queryPage, queryStateInfo, exportSaleContract } from '@/api/saleContract';
import setTableCols from './configs';
import {
  executionStatusGroup,
  collectionStatusOptions,
  deliveryStatusOptions,
  changeStatusOptions,
  billingStatusOptions,
} from '@/model/saleContract';

export default {
  name: 'sale_contract',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  data () {
    return {
      columnList: setTableCols.call(this),
      dataList: [],
      executionStatusGroup,
      advancedForm: {
        state: '',
        receiverName: '',
        receiverPhone: '',
        remark: '',
      },
      collectionStatusOptions,
      deliveryStatusOptions,
      changeStatusOptions,
      billingStatusOptions,
    };
  },
  created () {
    this.$store.dispatch('changeDefaultActive', this.$route.name);

    if (this.$route.query.status || this.$route.query.status === 0) {
      this.advancedForm.state = this.$route.query.status + '';
    }

    this.getList();
    this.getSaleContractCount();
  },
  methods: {
    getList (type) {
      if (type === 'init') {
        this.pagination = {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        };
      }

      let { pageSize, currentPage: pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      queryPage({ ...this.advancedForm, orderBy, pageSize, pageNum, flag: 1 }).then(
        ({ body }) => {
          this.dataList = body.list;
          this.pagination.total = body.total;
        },
      );
    },
    getSaleContractCount () {
      queryStateInfo().then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
      });
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.pagination = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };

      this.getList();
    },
    operate (type, row) {
      let path = '/saleContract/detail';

      if (type !== 'detail') {
        path = '/saleContract/review';
      }

      this.$router.push({
        path: path,
        query: {
          id: row.id,
          type,
        },
      });
    },
    handleExport () {
      let { pageSize, currentPage: pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];
      exportSaleContract({ ...this.advancedForm, orderBy, pageSize, pageNum, flag: 1 }).then(({data})=>{
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `销售合同_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      });
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>
<style lang="scss" scoped>
.xz-contract {
  /deep/ .contract-option {
    color: #02a7f0;
    cursor: pointer;
    padding: 0 0.25em;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
